import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Client from '../../../../lib/publicGqlClient';
import { GetAppInfoList } from '../gqls';
import { message } from 'antd';
const CheckNewVerisonPage = (props) => {
    const navigate = useNavigate();
    React.useEffect(() => {
        console.log(getQueryString("id"))
        getAppInfoList(getQueryString("id"))
    }, [])
    function getAppInfoList(id) {
        Client(
            GetAppInfoList,
            {
                projectId: id,
            },
        ).then((res) => {
            console.log(res)
            if (res !== null) {
              var newVsrsionId;
              var newVsrsionTime=0;
              res.data.getAppInfoList.map(item=>{
                  const date = new Date(item.createdAt); 
                  if(newVsrsionTime<date){
                      newVsrsionTime=date;
                      newVsrsionId=item._id
                  }
              })
              if(newVsrsionId){
              navigate('/developerCenter/apk/appDetails?id=' + newVsrsionId
              )
            }else{
                message.error('获取新版本失败');
            }
            }

        }).catch(e => {
            // console.log(e);
        })

    }

    return (
        <div style={{ height: '100%', width: '100%', }}>
          
            
        </div>
    );

    function getQueryString(name) {
        // 未传参，返回空
        if (!name) return null;
        // 查询参数：先通过search取值，如果取不到就通过hash来取
        var after = window.location.search;
        after = after.substr(1) || window.location.hash.split("?")[1];
        // 地址栏URL没有查询参数，返回空
        if (!after) return null;
        // 如果查询参数中没有"name"，返回空
        if (after.indexOf(name) === -1) return null;
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        // 当地址栏参数存在中文时，需要解码，不然会乱码
        var r = decodeURI(after).match(reg);
        // 如果url中"name"没有值，返回空
        if (!r) return null;
        return r[2];
    }
}

export default CheckNewVerisonPage